const onhandCheckLogic = (inventoryUnit, factorKg, onHandQnty, articleWeight) => {
  //kg m pcs
  if (inventoryUnit == "kg") {
    if (articleWeight > onHandQnty) {
      return true;
    }
  } else if (inventoryUnit == "m" || inventoryUnit == "pcs") {
    let onhandWeight = onHandQnty / factorKg;
    if (articleWeight > onhandWeight) {
      return true;
    }
  }
  return false;
};
export default onhandCheckLogic;
